export default __webpack_public_path__ + "static/media/StadisticsSelectedIcon.9d180d3d.svg";